export default {
  // Common
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    search: 'Suchen',
    filter: 'Filtern',
    loading: 'Wird geladen...',
    noData: 'Keine Daten',
    confirm: 'Bestätigen',
    close: 'Schließen',
    yes: 'Ja',
    no: 'Nein',
    actions: 'Aktionen',
    status: 'Status',
    date: 'Datum',
    name: 'Name',
    description: 'Beschreibung',
    type: 'Typ',
    download: 'Herunterladen',
    upload: 'Hochladen',
    copy: 'Kopieren',
    copied: 'Kopiert!',
    error: 'Fehler',
    success: 'Erfolg',
    warning: 'Warnung',
    info: 'Information',
    all: 'Alle',
    allTypes: 'Alle Typen',
    allStatuses: 'Alle Status',
    none: 'Keine',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    refresh: 'Aktualisieren',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    finish: 'Fertig',
    submit: 'Absenden',
    confirmDeleteItem: 'Möchten Sie dieses Element löschen?',
    validateForReport: 'Für Bericht validieren',
    reset: 'Zurücksetzen',
    view: 'Ansehen',
    details: 'Details',
    more: 'Mehr',
    less: 'Weniger',
    today: 'Heute',
    yesterday: 'Gestern',
    thisWeek: 'Diese Woche',
    thisMonth: 'Dieser Monat',
    optional: 'optional',
    required: 'Erforderlich',
    note: 'Hinweis:',
    and: 'und'
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    scans: 'Scans',
    workspaces: 'Workspaces',
    vulnerabilities: 'Schwachstellen',
    reports: 'Berichte',
    settings: 'Einstellungen',
    account: 'Mein Konto',
    logout: 'Abmelden',
    help: 'Hilfe',
    admin: 'Administration',
    tools: 'Werkzeuge',
    compliance: 'Compliance',
    notifications: 'Benachrichtigungen',
    credentials: 'Anmeldedaten',
    ad: 'Active Directory'
  },

  // Auth
  auth: {
    login: 'Anmelden',
    logout: 'Abmelden',
    register: 'Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    forgotPassword: 'Passwort vergessen?',
    magicLink: 'Magic Link',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordNeedsLink: 'Um Ihr Passwort zurückzusetzen, verwenden Sie den per E-Mail gesendeten Link. Sie können einen neuen Link von der Anmeldeseite anfordern.',
    rememberMe: 'Angemeldet bleiben',
    loginSuccess: 'Anmeldung erfolgreich',
    loginError: 'Ungültige Anmeldedaten',
    logoutSuccess: 'Abmeldung erfolgreich',
    sessionExpired: 'Sitzung abgelaufen',
    twoFactor: 'Zwei-Faktor-Authentifizierung',
    enterCode: 'Code eingeben',
    verifyCode: 'Code überprüfen',
    invalidCode: 'Ungültiger Code',
    // Register page
    createAccount: 'Konto erstellen',
    fillFormBelowEmail: 'Füllen Sie das Formular aus, um Ihr Geschäftskonto zu erstellen.',
    companyName: 'Firmenname',
    companyPlaceholder: 'Ihre Firma',
    firstName: 'Vorname',
    firstNamePlaceholder: 'Ihr Vorname',
    lastName: 'Nachname',
    lastNamePlaceholder: 'Ihr Nachname',
    professionalEmail: 'Geschäftliche E-Mail',
    professionalEmailPlaceholder: 'sie@ihrefirma.de',
    professionalPhone: 'Geschäftstelefon',
    phonePlaceholder: '+49 123 456 7890',
    passwordEmailNote: 'Sie werden Ihr Passwort nach der E-Mail-Bestätigung festlegen.',
    acceptTermsPrefix: 'Ich akzeptiere die',
    createMyAccount: 'Mein Konto erstellen',
    registering: 'Wird erstellt...',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
    loginButton: 'Anmelden',
    byRegistering: 'Mit der Erstellung eines Kontos akzeptieren Sie unsere Nutzungsbedingungen und Datenschutzrichtlinie.',
    registrationSuccess: 'Registrierung erfolgreich!',
    registrationEmailSent: 'Eine Bestätigungs-E-Mail wurde gesendet an',
    clickLinkToSetPassword: 'Klicken Sie auf den Link, um Ihr Passwort festzulegen und Ihr Konto zu aktivieren.',
    checkSpam: 'Prüfen Sie Ihren Spam-Ordner, wenn Sie die E-Mail nicht sehen.',
    backToLogin: 'Zurück zur Anmeldung',
    // Email verification
    verifying: 'Überprüfung...',
    verifyingDescription: 'Bitte warten Sie, während wir Ihre E-Mail-Adresse überprüfen.',
    emailVerified: 'E-Mail bestätigt!',
    accountActive: 'Ihr Konto ist jetzt aktiv.',
    welcome: 'Willkommen bei SYLink!',
    choosePlan: 'Meinen Plan wählen',
    redirectingToPlan: 'Weiterleitung zu den Preisen in {seconds} Sekunden...',
    orLoginDirectly: 'Oder {loginLink} direkt',
    verificationFailed: 'Überprüfung fehlgeschlagen',
    needNewVerificationLink: 'Benötigen Sie einen neuen Bestätigungslink?',
    yourEmail: 'Ihre E-Mail',
    emailSent: 'E-Mail gesendet!',
    resendLink: 'Link erneut senden',
    invalidLink: 'Ungültiger Link',
    requestNewVerificationLink: 'Neuen Bestätigungslink anfordern',
    sendLink: 'Link senden',
    // Login page
    welcomeBack: 'Willkommen zurück!',
    enterCredentials: 'Geben Sie Ihre Anmeldedaten ein, um auf Ihren Bereich zuzugreifen.',
    loggingIn: 'Anmeldung...',
    noAccount: 'Noch kein Konto?',
    createAccountLink: 'Konto erstellen',
    createFreeAccount: 'Kostenloses Konto erstellen',
    // Password reset
    resetPasswordTitle: 'Passwort zurücksetzen',
    resetPasswordDesc: 'Geben Sie Ihre E-Mail ein, um einen Zurücksetzungslink zu erhalten.',
    sendResetLink: 'Link senden',
    sending: 'Wird gesendet...',
    resetLinkSent: 'Link gesendet!',
    resetLinkSentDesc: 'Prüfen Sie Ihr Postfach, um Ihr Passwort zurückzusetzen.',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Passwort bestätigen',
    setNewPassword: 'Passwort festlegen',
    passwordUpdated: 'Passwort aktualisiert!',
    passwordUpdatedDesc: 'Sie können sich jetzt mit Ihrem neuen Passwort anmelden.'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Willkommen, {name}',
    overview: 'Übersicht',
    recentScans: 'Neueste Scans',
    statistics: 'Statistiken',
    quickActions: 'Schnellaktionen',
    newScan: 'Neuer Scan',
    viewAllScans: 'Alle Scans anzeigen',
    totalScans: 'Gesamte Scans',
    activeScans: 'Aktive Scans',
    completedScans: 'Abgeschlossene Scans',
    failedScans: 'Fehlgeschlagene Scans',
    vulnerabilitiesFound: 'Gefundene Schwachstellen',
    criticalVulns: 'Kritische Schwachstellen',
    highVulns: 'Hohe Schwachstellen',
    mediumVulns: 'Mittlere Schwachstellen',
    lowVulns: 'Niedrige Schwachstellen',
    systemHealth: 'Systemzustand',
    toolsStatus: 'Werkzeugstatus',
    cpuUsage: 'CPU-Auslastung',
    memoryUsage: 'Speicherauslastung',
    diskUsage: 'Festplattenauslastung',
    // Service status
    services: {
      backendApi: 'Backend API',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'KI-Modelle'
    },
    serviceStatus: {
      online: 'Online',
      offline: 'Offline',
      checking: 'Überprüfung',
      degraded: 'Beeinträchtigt'
    }
  },

  // Scans
  scans: {
    title: 'Scans',
    newScan: 'Neuer Scan',
    scanHistory: 'Scan-Verlauf',
    target: 'Ziel',
    targets: 'Ziele',
    scanType: 'Scan-Typ',
    startScan: 'Scan starten',
    stopScan: 'Scan stoppen',
    pauseScan: 'Pausieren',
    resumeScan: 'Fortsetzen',
    deleteScan: 'Scan löschen',
    scanDetails: 'Scan-Details',
    scanResults: 'Scan-Ergebnisse',
    progress: 'Fortschritt',
    duration: 'Dauer',
    startedAt: 'Gestartet am',
    completedAt: 'Abgeschlossen am',
    status: {
      waiting: 'In Warteschlange',
      pending: 'Ausstehend',
      running: 'Läuft',
      completed: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
      cancelled: 'Abgebrochen',
      paused: 'Pausiert'
    },
    types: {
      quick: 'Schnell-Scan',
      full: 'Vollständiger Scan',
      stealth: 'Stealth-Scan',
      aggressive: 'Aggressiver Scan',
      custom: 'Benutzerdefinierter Scan',
      iot_scan: 'IoT-Scan',
      ot_scan: 'OT/SCADA-Scan',
      full_autonomous: 'Voll autonom',
      full_auto: 'Voll autonom',
      full_automation: 'Voll autonom',
      network_discovery: 'Netzwerkerkennung',
      vulnerability_scan: 'Schwachstellen-Scan',
      expert: 'Experten-Scan',
      api_pentest: 'API-Pentest',
      ad_pentest: 'Active Directory Pentest',
      ad_scan: 'Active Directory Scan',
      wifi_pentest: 'WLAN-Pentest',
      social_engineering: 'Social Engineering',
      red_team: 'Red Team',
      phishing: 'Phishing-Kampagne'
    },
    phases: {
      discovery: 'Erkennung',
      portScan: 'Port-Scan',
      serviceDetection: 'Diensterkennung',
      vulnScan: 'Schwachstellen-Scan',
      exploitation: 'Exploitation',
      reporting: 'Berichterstellung'
    },
    stealthMode: {
      title: 'Stealth-Modus',
      description: 'IDS/IPS-Umgehungstechniken',
      none: 'Keiner',
      noneDesc: 'Schneller Scan, leicht erkennbar',
      basic: 'Einfach',
      basicDesc: 'Fragmentierte Pakete',
      advanced: 'Erweitert',
      advancedDesc: 'Langsames Timing + Spoofing',
      paranoid: 'Paranoid',
      paranoidDesc: 'Maximale Umgehung (sehr langsam)',
      warning: 'Stealth-Modi verwenden Umgehungstechniken zur Vermeidung der IDS/IPS-Erkennung'
    },
    hosts: 'Hosts',
    ports: 'Ports',
    services: 'Dienste',
    openPorts: 'Offene Ports',
    closedPorts: 'Geschlossene Ports',
    filteredPorts: 'Gefilterte Ports',
    noResults: 'Keine Ergebnisse gefunden',
    exportResults: 'Ergebnisse exportieren',
    scanFailed: 'Scan fehlgeschlagen',
    genericError: 'Bei der Scan-Ausführung ist ein Fehler aufgetreten. Dies kann auf Netzwerkverbindungsprobleme, unerreichbare Ziele oder unzureichende Ressourcen zurückzuführen sein.',
    technicalDetails: 'Technische Details',
    retryScan: 'Scan erneut starten',
    // Cleanup mode
    cleanup: 'Bereinigung',
    cleanupTitle: 'Post-Pentest Bereinigung',
    cleanupDescription: 'Diese Aktion entfernt alle vom Pentest hinterlassenen Spuren, einschließlich:',
    cleanupSessions: 'Aktive Exploitation-Sitzungen',
    cleanupPersistence: 'Installierte Persistenzmechanismen',
    cleanupFiles: 'Temporäre Dateien und Beweise',
    cleanupLogs: 'APT-Ausführungsprotokolle',
    cleanupPreview: 'Bereinigungsvorschau',
    sessionsCount: 'Sitzungen',
    withPersistence: 'Mit Persistenz',
    aptExecutions: 'APT-Ausführungen',
    evidenceFiles: 'Beweisdateien',
    evidenceSize: 'Beweisgröße',
    cleanNow: 'Jetzt bereinigen',
    archiveAndClean: 'Archivieren und bereinigen',
    cleaning: 'Bereinigung...',
    cleanupSuccess: 'Bereinigung erfolgreich abgeschlossen',
    cleanupPartial: 'Teilweise Bereinigung (einige Fehler)',
    cleanupFailed: 'Bereinigung fehlgeschlagen',
    sessionsClosed: 'Sitzungen geschlossen',
    persistenceRemoved: 'Persistenz entfernt',
    filesCleaned: 'Dateien bereinigt',
    aptLogsCleaned: 'APT-Protokolle bereinigt',
    evidenceArchived: 'Beweise archiviert',
    cleanupWarning: '⚠️ Diese Aktion ist unwiderruflich. Stellen Sie sicher, dass Sie wichtige Daten gespeichert haben.'
  },

  // Workspaces
  workspaces: {
    title: 'Kundenbereiche',
    newWorkspace: 'Neuer Bereich',
    editWorkspace: 'Bereich bearbeiten',
    deleteWorkspace: 'Bereich löschen',
    workspaceDetails: 'Bereichsdetails',
    clientName: 'Kundenname',
    clientInfo: 'Kundeninformationen',
    members: 'Mitglieder',
    addMember: 'Mitglied hinzufügen',
    removeMember: 'Mitglied entfernen',
    scansCount: 'Anzahl der Scans',
    lastActivity: 'Letzte Aktivität',
    created: 'Erstellt am',
    shareWorkspace: 'Bereich teilen',
    archiveWorkspace: 'Bereich archivieren',
    noWorkspaces: 'Keine Kundenbereiche',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'z.B. 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'z.B. 123 456 789',
    // Additional workspace keys
    scans: 'Scans',
    hosts: 'Hosts',
    vulnerabilities: 'Schwachstellen',
    attackPaths: 'Angriffspfade',
    successfulScans: 'Erfolgreiche Scans',
    company: 'Unternehmen',
    legalForm: 'Rechtsform',
    address: 'Adresse',
    city: 'Stadt',
    website: 'Website',
    shareDescription: 'Teilen Sie diesen Bereich mit Ihren Kunden oder Mitarbeitern',
    manageShares: 'Freigaben verwalten',
    mainContact: 'Hauptkontakt',
    contact: 'Kontakt',
    signed: 'Unterzeichnet',
    pending: 'Ausstehend',
    draft: 'Entwurf',
    contractSigned: 'Vertrag unterzeichnet',
    pendingContract: 'Vertrag ausstehend',
    noContract: 'Kein Vertrag',
    noScans: 'Keine Scans zugeordnet',
    noScansHint: 'Verknüpfen Sie einen vorhandenen Scan oder starten Sie einen neuen von der Scans-Seite',
    noHosts: 'Keine Hosts',
    noVulnerabilities: 'Keine Schwachstellen',
    noAttackPaths: 'Keine Angriffspfade',
    // Network stats
    vulnerable: 'Verwundbar',
    subnets: 'Subnetze',
    services: 'Dienste',
    noAttackTree: 'Kein Angriffsbaum',
    noVPN: 'Kein VPN konfiguriert',
    // AI Analysis
    aiAnalysis: 'KI-Analyse',
    generateSummary: 'Zusammenfassung generieren',
    launchAiAnalysis: 'KI-Analyse starten',
    analysisInProgress: 'Analyse läuft...',
    completeAnalysis: 'Vollständige Analyse & Lösungen',
    aggregatedData: 'Aggregierte Daten',
    riskAnalysis: 'Risikoanalyse',
    clickToGenerateSummary: 'Klicken Sie auf "Zusammenfassung generieren" für eine KI-Analyse',
    noAnalysisAvailable: 'Keine Analyse verfügbar',
    clickToLaunchAnalysis: 'Klicken Sie auf die Schaltfläche oben, um die KI-Analyse zu starten',
    launchScanToDiscoverNetwork: 'Starten Sie einen Scan, um das Netzwerk zu entdecken',
    critical: 'Kritisch',
    high: 'Hoch',
    download: 'Herunterladen',
    deleteStoredCredentials: 'Gespeicherte Anmeldedaten löschen',
    useStoredCredentials: 'gespeicherte Anmeldedaten verwenden',
    enterVpnUsername: 'VPN-Benutzernamen eingeben',
    enterVpnPassword: 'VPN-Passwort eingeben',
    // VPN Modal
    actionPlan: 'Aktionsplan & Lösungen',
    noDocuments: 'Keine Dokumente für diesen Workspace generiert',
    reportsWillAppear: 'Berichte erscheinen hier nach der Generierung',
    vpnCredentials: 'VPN-Anmeldedaten',
    requiresAuthentication: 'erfordert Authentifizierung',
    storedCredentials: 'Gespeicherte Anmeldedaten',
    clickToUseCredentials: 'Klicken Sie auf "Verbinden", um diese Anmeldedaten zu verwenden',
    connect: 'Verbinden',
    cancel: 'Abbrechen',
    username: 'Benutzername',
    password: 'Passwort',
    saveCredentials: 'Diese Anmeldedaten speichern',
    saveCredentialsSecurely: 'Anmeldedaten sicher speichern',
    credentialsStorageInfo: 'Anmeldedaten werden verschlüsselt (AES-256) und in der Datenbank gespeichert. Sie werden automatisch für zukünftige VPN-Verbindungen verwendet.',
    saving: 'Speichern...',
    connecting: 'Verbinden...',
    server: 'Server',
    protocol: 'Protokoll',
    noVulnsToFix: 'Keine Schwachstellen zu beheben',
    connectionInProgress: 'Verbindung wird hergestellt...',
    connectionFailed: 'Verbindung fehlgeschlagen',
    generateActionPlan: 'Aktionsplan generieren',
    clickToGenerateActionPlan: 'Klicken Sie auf "Aktionsplan generieren", um Empfehlungen zu erhalten',
    vpnConnected: 'VPN verbunden! IP:',

    // Workspace Switcher
    selectTitle: 'Arbeitsbereich auswählen',
    selectDescription: 'Wählen Sie einen Arbeitsbereich, um fortzufahren',
    searchPlaceholder: 'Arbeitsbereiche durchsuchen...',
    noWorkspacesYet: 'Noch keine Arbeitsbereiche',
    noResults: 'Keine passenden Arbeitsbereiche',
    createFirst: 'Ersten Arbeitsbereich erstellen',
    createNew: 'Neu erstellen',
    continue: 'Fortfahren',
    switchError: 'Fehler beim Wechseln des Arbeitsbereichs',
    scan: 'Scan',
    scans: 'Scans',
    select: 'Arbeitsbereich auswählen',
    manageAll: 'Arbeitsbereiche verwalten',
    noWorkspaces: 'Keine Arbeitsbereiche gefunden',
    switching: 'Wechseln...',
    switchSuccess: 'Arbeitsbereich erfolgreich gewechselt',
    autoSelected: 'Arbeitsbereich automatisch ausgewählt',
    pleaseSelect: 'Bitte wählen Sie einen Arbeitsbereich aus, um fortzufahren',
    activeWorkspace: 'Aktiver Arbeitsbereich'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Schwachstellen',
    subtitle: 'Analyse und Verwaltung erkannter Schwachstellen',
    vulnerability: 'Schwachstelle',
    severity: 'Schweregrad',
    severities: {
      critical: 'Kritisch',
      high: 'Hoch',
      medium: 'Mittel',
      low: 'Niedrig',
      info: 'Information'
    },
    cve: 'CVE',
    cvss: 'CVSS-Score',
    affected: 'Betroffen',
    solution: 'Lösung',
    references: 'Referenzen',
    evidence: 'Beweise',
    exploitable: 'Ausnutzbar',
    verified: 'Verifiziert',
    falsePositive: 'Falsch-Positiv',
    validation: {
      confirmed: 'Bestätigt ausnutzbar',
      theoretical: 'Theoretisch',
      not_exploitable: 'Nicht ausnutzbar',
      unvalidated: 'Nicht validiert',
      poc_title: 'Proof of Concept',
      narrative: 'Ausnutzungsnarrativ',
      exploit_path: 'Exploit-Pfad',
      prerequisites: 'Voraussetzungen',
    },
    markAsFixed: 'Als behoben markieren',
    noVulnerabilities: 'Keine Schwachstellen gefunden',
    export: 'Schwachstellen exportieren',
    distributionBySeverity: 'Verteilung nach Schweregrad',
    priority: {
      auto: 'Automatisch',
    },
    // Attack Chain
    attackChain: {
      title: 'Angriffsketten-Ranking',
      subtitle: 'Multi-Schwachstellen-Risikoanalyse für Zielpenetration',
      riskScore: 'Risikobewertung',
      vulnCount: 'Schwachstellen',
      attackPath: 'Angriffspfad zum Ziel',
      // Chart
      chartTitle: 'Schwachstellen-Verteilung',
      chartSubtitle: 'Statistische Analyse erkannter CVEs',
      bySeverity: 'Verteilung nach Schweregrad',
      keyMetrics: 'Schlüsselmetriken',
      totalVulns: 'Gesamt CVE',
      avgCvss: 'Durchschnittlicher CVSS',
      criticalHigh: 'Kritisch + Hoch',
      affectedHosts: 'Betroffene Hosts',
      topCves: 'Top CVE nach CVSS',
      // Stages
      stages: {
        initialAccess: 'Erstzugang',
        privEscalation: 'Rechteausweitung',
        persistence: 'Persistenz',
        objective: 'Ziel'
      },
      exploitVia: 'Ausnutzung via',
      escalationVia: 'Eskalation via',
      maintenanceVia: 'Persistenz via',
      fullCompromise: 'Vollständige Systemkompromittierung',
      adminAccess: 'Admin-Zugang möglich',
      initialSystemAccess: 'Initialer Systemzugang',
      // Risk Factors
      riskFactors: 'Risikofaktoren',
      factors: {
        multiVuln: 'Multi-Schwachstellen',
        multiVuln5: '{count} verkettbare Vulns',
        multiVuln3: '{count} Vulns auf diesem Host',
        criticalHighCombo: 'Critical + High Combo',
        rce: 'Potenzieller RCE',
        authBypass: 'Auth-Umgehung möglich',
        privEsc: 'Rechteausweitung',
        exposed: 'Exponierte Dienste',
        highCvss: 'Durchschnittlicher CVSS {score}'
      },
      // Ratings
      ratingCritical: 'KRITISCH',
      ratingHigh: 'HOCH',
      ratingMedium: 'MITTEL',
      ratingLow: 'NIEDRIG',
      ratingSafe: 'SICHER',
      // Details
      criticalPath: 'KRITISCHER PFAD',
      vulnsInChain: 'Schwachstellen in dieser Kette',
      noChains: 'Keine Angriffsketten erkannt',
      noVulnsDesc: 'Keine Schwachstellen gefunden zur Analyse von Angriffspfaden.',
      viewDetails: 'Details anzeigen',
      multiVulnWarning: 'Erhöhtes Risiko: mehrere verkettbare Schwachstellen',
      // Recommendations
      recommendation: 'Ausnutzungsempfehlung',
      recoCritical: 'Dieses Ziel stellt ein kritisches Risiko dar. Die Kombination von {count} Schwachstellen ermöglicht vollständige Systemkompromittierung. Höchste Priorität für Behebung.',
      recoHigh: 'Hohes Kompromittierungsrisiko. Kombinierte Schwachstellen bieten einen gangbaren Angriffspfad. Korrekturmaßnahmen schnellstmöglich empfohlen.',
      recoMedium: 'Moderates Risiko. Einige Schwachstellen könnten für Ausnutzung verkettet werden. Überwachen und nach Priorität beheben.',
      recoLow: 'Niedriges Risiko. Vorhandene Schwachstellen haben begrenzten Einfluss und sind schwer verkettbar.',
      // Stats
      criticalPaths: 'Kritische Pfade',
      highRisk: 'Hohes Risiko',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Analysierte Hosts',
      avgScore: 'Durchschnittswertung',
      // Info
      infoText: 'Diese Rangfolge identifiziert die anfälligsten Hosts durch Analyse ausnutzbarer Schwachstellenkombinationen zur Erreichung von Penetrationszielen.',
      // Legend
      legendCritical: 'Kritisch (80-100)',
      legendHigh: 'Hoch (60-79)',
      legendMedium: 'Mittel (40-59)',
      legendLow: 'Niedrig (20-39)',
      legendSafe: 'Sicher (0-19)'
    }
  },

  // Reports
  reports: {
    title: 'Berichte',
    newReport: 'Neuer Bericht',
    generateReport: 'Bericht erstellen',
    downloadReport: 'Bericht herunterladen',
    reportType: 'Berichtstyp',
    settings: 'Einstellungen',
    branding: 'Branding',
    types: {
      executive: 'Executive-Bericht',
      technical: 'Technischer Bericht',
      compliance: 'Compliance-Bericht',
      full: 'Vollständiger Bericht',
      vulnerability_list: 'Schwachstellenbericht',
      redteam: 'Red-Team-Bericht',
      retest: 'Retest-Bericht',
      multi_campaign: 'Multi-Kampagnen-Bericht',
      active_directory: 'Active-Directory-Bericht',
      data_leak: 'Datenleck-Bericht',
      attack_surface: 'Angriffsflächen-Bericht'
    },
    format: 'Format',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Text (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Beweise einschließen',
    includeRemediation: 'Empfehlungen einschließen',
    generatedAt: 'Erstellt am',
    generatedBy: 'Erstellt von',
    noReports: 'Keine Berichte',
    // Export modal
    export: {
      title: 'Export',
      processing: 'Exportiere...',
      generating: 'Datei wird erstellt',
      takingLong: 'Dieser Vorgang dauert länger als erwartet.',
      canWaitOrEmail: 'Sie können warten oder dieses Fenster schließen und wir senden Ihnen einen Link per E-Mail.',
      sendByEmail: 'Per E-Mail senden',
      continueWaiting: 'Sie können auch weiter warten, der Download startet automatisch.',
      emailSent: 'E-Mail gesendet!',
      emailSentDesc: 'Sie erhalten den Download-Link in Kürze per E-Mail.',
      wordLocked: 'Verfügbar für Enterprise-Pläne und höher'
    }
  },

  // Account
  account: {
    title: 'Mein Konto',
    profile: 'Profil',
    security: 'Sicherheit',
    subscription: 'Abonnement',
    billing: 'Abrechnung',
    credits: 'Guthaben',
    notifications: 'Benachrichtigungen',
    integrations: 'Integrationen',
    referral: 'Empfehlungsprogramm',
    activity: 'Aktivität',
    contracts: 'Verträge',

    // Profile section
    profileSection: {
      title: 'Profilinformationen',
      avatar: 'Profilbild',
      changeAvatar: 'Bild ändern',
      removeAvatar: 'Bild entfernen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Unternehmen',
      position: 'Position',
      timezone: 'Zeitzone',
      language: 'Portalsprache',
      languageDescription: 'Wählen Sie die Anzeigesprache der Oberfläche',
      updateSuccess: 'Profil erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren des Profils'
    },

    // Security section
    securitySection: {
      title: 'Kontosicherheit',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      passwordRequirements: 'Das Passwort muss mindestens 8 Zeichen haben',
      twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
      enable2FA: '2FA aktivieren',
      disable2FA: '2FA deaktivieren',
      twoFactorEnabled: '2FA aktiviert',
      twoFactorDisabled: '2FA deaktiviert',
      activeSessions: 'Aktive Sitzungen',
      revokeSession: 'Sitzung widerrufen',
      revokeAllSessions: 'Alle Sitzungen widerrufen',
      loginHistory: 'Anmeldeverlauf',
      lastLogin: 'Letzte Anmeldung',
      apiKeys: 'API-Schlüssel',
      generateApiKey: 'API-Schlüssel generieren',
      deleteApiKey: 'API-Schlüssel löschen'
    },

    // Subscription section
    subscriptionSection: {
      title: 'Abonnement',
      currentPlan: 'Aktueller Plan',
      planDetails: 'Plandetails',
      features: 'Enthaltene Funktionen',
      usage: 'Nutzung',
      limits: 'Limits',
      renewalDate: 'Verlängerungsdatum',
      cancelSubscription: 'Abonnement kündigen',
      upgradePlan: 'Plan upgraden',
      downgradePlan: 'Plan downgraden',
      plans: {
        free: 'Kostenlos',
        pro: 'Pro',
        enterprise: 'Enterprise',
        dedicated: 'Dediziert'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Guthabenverwaltung',
      balance: 'Guthaben',
      totalCredits: 'Gesamtguthaben',
      monthlyCredits: 'Monatliches Guthaben',
      packCredits: 'Paket-Guthaben',
      usedThisMonth: 'Diesen Monat verwendet',
      remaining: 'Verbleibend',
      buyCredits: 'Guthaben kaufen',
      creditHistory: 'Guthaben-Verlauf',
      transaction: 'Transaktion',
      amount: 'Betrag',
      creditCosts: 'Operationskosten',
      scanCost: 'Scan-Kosten',
      reportCost: 'Bericht-Kosten'
    },

    // Notifications section
    notificationsSection: {
      title: 'Benachrichtigungseinstellungen',
      emailNotifications: 'E-Mail-Benachrichtigungen',
      pushNotifications: 'Push-Benachrichtigungen',
      scanCompleted: 'Scan abgeschlossen',
      scanFailed: 'Scan fehlgeschlagen',
      newVulnerability: 'Neue kritische Schwachstelle',
      reportReady: 'Bericht bereit',
      securityAlerts: 'Sicherheitswarnungen',
      weeklyDigest: 'Wöchentliche Zusammenfassung',
      marketingEmails: 'Marketing-E-Mails'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integrationen',
      connected: 'Verbunden',
      notConnected: 'Nicht verbunden',
      configure: 'Konfigurieren',
      disconnect: 'Trennen',
      testConnection: 'Verbindung testen',
      connectionSuccess: 'Verbindung erfolgreich',
      connectionFailed: 'Verbindung fehlgeschlagen',
      availableIntegrations: 'Verfügbare Integrationen',
      myIntegrations: 'Meine Integrationen'
    },

    // Referral section
    referralSection: {
      title: 'Empfehlungsprogramm',
      referralLink: 'Empfehlungslink',
      copyLink: 'Link kopieren',
      shareLink: 'Link teilen',
      inviteFriends: 'Freunde einladen',
      referralStats: 'Empfehlungsstatistiken',
      totalReferrals: 'Gesamte Empfehlungen',
      pendingReferrals: 'Ausstehende Empfehlungen',
      completedReferrals: 'Abgeschlossene Empfehlungen',
      earnedCredits: 'Verdientes Guthaben',
      inviteByEmail: 'Per E-Mail einladen',
      contacts: 'Eingeladene Kontakte',
      rewards: 'Belohnungen',
      leaderboard: 'Rangliste'
    }
  },

  // Settings
  settings: {
    title: 'Einstellungen',
    general: 'Allgemein',
    tools: 'Werkzeuge',
    network: 'Netzwerk',
    advanced: 'Erweitert',

    generalSection: {
      title: 'Allgemeine Einstellungen',
      defaultScanType: 'Standard-Scan-Typ',
      defaultReportFormat: 'Standard-Berichtsformat',
      autoSaveReports: 'Berichte automatisch speichern',
      enableNotifications: 'Benachrichtigungen aktivieren',
      darkMode: 'Dunkelmodus',
      compactView: 'Kompakte Ansicht'
    },

    toolsSection: {
      title: 'Werkzeugkonfiguration',
      enabledTools: 'Aktivierte Werkzeuge',
      toolSettings: 'Werkzeugeinstellungen',
      timeout: 'Zeitüberschreitung',
      threads: 'Thread-Anzahl',
      verbosity: 'Detailstufe'
    },

    networkSection: {
      title: 'Netzwerkkonfiguration',
      proxySettings: 'Proxy-Einstellungen',
      vpnSettings: 'VPN-Einstellungen',
      dnsSettings: 'DNS-Einstellungen',
      useProxy: 'Proxy verwenden',
      proxyHost: 'Proxy-Host',
      proxyPort: 'Proxy-Port'
    },

    // Server status
    uptime: 'Betriebszeit'
  },

  // Admin
  admin: {
    title: 'Administration',
    users: 'Benutzer',
    companies: 'Unternehmen',
    system: 'System',
    logs: 'Protokolle',
    maintenance: 'Wartung',

    usersSection: {
      title: 'Benutzerverwaltung',
      addUser: 'Benutzer hinzufügen',
      editUser: 'Benutzer bearbeiten',
      deleteUser: 'Benutzer löschen',
      activateUser: 'Benutzer aktivieren',
      deactivateUser: 'Benutzer deaktivieren',
      resetPassword: 'Passwort zurücksetzen',
      role: 'Rolle',
      roles: {
        admin: 'Administrator',
        user: 'Benutzer',
        viewer: 'Betrachter'
      },
      lastLogin: 'Letzte Anmeldung',
      createdAt: 'Erstellt am',
      noUsers: 'Keine Benutzer'
    },

    systemSection: {
      title: 'System',
      systemInfo: 'Systeminformationen',
      version: 'Version',
      uptime: 'Laufzeit',
      restart: 'Neustart',
      backup: 'Sicherung',
      restore: 'Wiederherstellen',
      update: 'Aktualisieren'
    }
  },

  // Errors
  errors: {
    generic: 'Ein Fehler ist aufgetreten',
    notFound: 'Seite nicht gefunden',
    unauthorized: 'Nicht autorisiert',
    forbidden: 'Zugriff verweigert',
    serverError: 'Serverfehler',
    networkError: 'Netzwerkfehler',
    timeout: 'Zeitüberschreitung',
    validation: 'Validierungsfehler',
    invalidEmail: 'Ungültige E-Mail',
    invalidPassword: 'Ungültiges Passwort',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    requiredField: 'Dieses Feld ist erforderlich',
    minLength: 'Mindestens {min} Zeichen erforderlich',
    maxLength: 'Maximal {max} Zeichen erlaubt',
    fillAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
    emailAlreadyUsed: 'Diese E-Mail wird bereits verwendet',
    companyAlreadyRegistered: 'Diese Firma ist bereits registriert',
    registrationError: 'Fehler bei der Registrierung',
    genericError: 'Ein unerwarteter Fehler ist aufgetreten',
    disposableEmailNotAllowed: 'Wegwerf-E-Mails sind nicht erlaubt',
    personalEmailNotAllowed: 'Die E-Mail {domain} ist nicht erlaubt. Verwenden Sie eine geschäftliche E-Mail.',
    invalidResetLink: 'Dieser Zurücksetzungslink ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.',
    resetLinkExpired: 'Dieser Zurücksetzungslink ist abgelaufen. Bitte fordern Sie einen neuen Link an.',
    resetPasswordFailed: 'Passwort-Zurücksetzung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    passwordCriteriaNotMet: 'Das Passwort erfüllt nicht alle erforderlichen Kriterien.'
  },

  // Success messages
  success: {
    saved: 'Erfolgreich gespeichert',
    deleted: 'Erfolgreich gelöscht',
    updated: 'Erfolgreich aktualisiert',
    created: 'Erfolgreich erstellt',
    copied: 'In Zwischenablage kopiert',
    sent: 'Erfolgreich gesendet',
    uploaded: 'Erfolgreich hochgeladen'
  },

  // Time
  time: {
    now: 'Jetzt',
    seconds: 'Sekunden',
    minutes: 'Minuten',
    hours: 'Stunden',
    days: 'Tage',
    weeks: 'Wochen',
    months: 'Monate',
    years: 'Jahre',
    ago: 'vor',
    in: 'in'
  },

  // Credentials
  credentials: {
    title: 'Anmeldedaten',
    username: 'Benutzername',
    password: 'Passwort',
    hash: 'Hash',
    domain: 'Domäne',
    source: 'Quelle',
    foundAt: 'Gefunden am',
    noCredentials: 'Keine Anmeldedaten gefunden',
    export: 'Anmeldedaten exportieren'
  },

  // Sessions
  sessions: {
    title: 'Sitzungen',
    sessionDetails: 'Sitzungsdetails',
    activeSession: 'Aktive Sitzung',
    closedSession: 'Geschlossene Sitzung',
    sessionType: 'Sitzungstyp',
    target: 'Ziel',
    startedAt: 'Gestartet am',
    endedAt: 'Beendet am',
    duration: 'Dauer',
    commands: 'Befehle',
    noSessions: 'Keine Sitzungen',
    closeSession: 'Sitzung schließen',
    quickActions: 'Schnellaktionen',
    quickCommands: 'Schnellbefehle',
    defaultSessionType: 'Terminal',
    sessionLabel: 'Sitzung',
    manualExploit: 'Manuell'
  },

  // Attack
  attack: {
    title: 'Angriffszentrum',
    description: 'Erweiterte Angriffswerkzeuge und dynamischer Orchestrator',
    selectTarget: 'Ziel auswählen',
    selectTechnique: 'Technik auswählen',
    launchAttack: 'Angriff starten',
    attackInProgress: 'Angriff läuft',
    attackCompleted: 'Angriff abgeschlossen',
    attackFailed: 'Angriff fehlgeschlagen',
    techniques: 'Techniken',
    payloads: 'Payloads',
    results: 'Ergebnisse',
    dynamicOrchestrator: 'Dynamischer Orchestrator',
    attackGraph: 'Angriffsgraph',
    attackBuilder: 'Angriffs-Builder'
  },

  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'AD-Angriffswerkzeuge mit KI-LLM-Unterstützung und automatisiertem PoC',
    domain: 'Domäne',
    dcIp: 'Domain Controller IP',
    username: 'Benutzername',
    password: 'Passwort',
    ntlmHash: 'NTLM-Hash (optional)',
    dcConfiguration: 'Domain Controller Konfiguration',
    attacks: 'AD-Angriffe',
    ldapPentest: 'LDAP/LDAPS Pentest',
    searchPlaceholder: 'Suche nach einem Angriff, einem Werkzeug...',
    allCategories: 'Alle Kategorien',
    attackCategories: 'Angriffskategorien',
    targetResults: 'Ziel / Ergebnisse',
    noDataMessage: 'Wählen Sie einen Angriff zum Starten',
    noDataHint: 'Oder verwenden Sie Auto PoC für eine Angriffskette',
    readyToStart: 'Bereit zum Starten',
    stats: {
      attacks: 'Angriffe',
      successful: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      credentials: 'Anmeldedaten',
      users: 'Benutzer',
      paths: 'Pfade'
    }
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Autonome',
    platformSubtitle: 'Pentest-Plattform',
    platformDescription: 'KI-gestützte Sicherheitsanalyse mit automatisierter Exploitation und detaillierten Berichten.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'Autonome KI',
      description: 'Künstliche Intelligenz, die einen erfahrenen Pentester simuliert',
      highlight: 'SYLink LLM On-Premise'
    },
    advancedDetection: {
      title: 'Erweiterte Erkennung',
      description: 'Automatische Identifizierung kritischer Schwachstellen',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Vollständige Tests',
      description: 'Netzwerk-, Web-, API- und Infrastruktur-Scans',
      highlight: '100+ Tools'
    },
    instantReports: {
      title: 'Sofortige Berichte',
      description: 'Automatische Erstellung professioneller PDF-Berichte',
      highlight: 'PDF-Export'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Verfügbarkeit',
    vulnerabilities: 'Erkannte Schwachstellen',
    monitoring: 'Überwachung',
    scanTime: 'Durchschnittliche Scan-Zeit'
  },

  // Footer
  footer: {
    title: 'Sicherheitsscanner-Plattform',
    subtitle: 'Autonomes Penetrationstest-System',
    terms: 'Nutzungsbedingungen',
    sales: 'Verkaufsbedingungen',
    privacy: 'Datenschutzrichtlinie',
    legalNotice: 'Impressum',
    contact: 'Kontakt',
    version: 'Version',
    licence: 'Lizenz Nr.'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Anreicherung & Bedrohungsintelligenz',
    subtitle: 'Erweiterte Domain- und IP-Analyse mit VirusTotal, Sicherheits-Headers, E-Mail und Geolokalisierung',
    newScan: 'Neuer Scan',
    quickScan: 'Schnellscan',
    fullScan: 'Vollständiger Scan',
    viewDetails: 'Details anzeigen',
    exportReport: 'Bericht exportieren',
    refresh: 'Aktualisieren',
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Sicherheits-Headers',
      security_headers: 'Sicherheits-Headers',
      email_security: 'E-Mail-Sicherheit',
      geoip: 'IP-Geolokalisierung',
      reverse_ip: 'Reverse IP',
      full: 'Vollständiger Scan'
    },
    status: {
      pending: 'Ausstehend',
      running: 'Läuft',
      completed: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
      cancelled: 'Abgebrochen'
    },
    threatLevels: {
      safe: 'Sicher',
      low: 'Niedrig',
      medium: 'Mittel',
      high: 'Hoch',
      critical: 'Kritisch'
    },
    form: {
      targetDomain: 'Zieldomain',
      targetDomainPlaceholder: 'z.B.: example.com',
      targetIp: 'IP-Adresse (optional)',
      targetIpPlaceholder: 'z.B.: 192.168.1.1',
      scanType: 'Scan-Typ',
      workspace: 'Workspace (optional)',
      startScan: 'Scan starten',
      credits: 'Erforderliche Credits'
    },
    results: {
      title: 'Ergebnisse',
      noResults: 'Keine Ergebnisse verfügbar',
      loading: 'Ergebnisse werden geladen...',
      riskScore: 'Risikobewertung',
      threatLevel: 'Bedrohungsstufe',
      scannedAt: 'Gescannt am',
      duration: 'Dauer'
    },
    headers: {
      title: 'Sicherheits-Header-Analyse',
      score: 'Punktzahl',
      grade: 'Note',
      present: 'Vorhanden',
      missing: 'Fehlend',
      recommendations: 'Empfehlungen',
      headerName: 'Header',
      value: 'Wert',
      status: 'Status',
      issues: 'Probleme'
    },
    email: {
      title: 'E-Mail-Sicherheit',
      mxRecords: 'MX-Einträge',
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      valid: 'Gültig',
      invalid: 'Ungültig',
      notFound: 'Nicht gefunden',
      policy: 'Richtlinie',
      vulnerabilities: 'Erkannte Schwachstellen',
      recommendations: 'Empfehlungen'
    },
    geoip: {
      title: 'IP-Geolokalisierung',
      location: 'Standort',
      country: 'Land',
      region: 'Region',
      city: 'Stadt',
      timezone: 'Zeitzone',
      isp: 'ISP',
      organization: 'Organisation',
      isProxy: 'Proxy erkannt',
      isVpn: 'VPN erkannt',
      isTor: 'Tor erkannt'
    },
    virustotal: {
      title: 'VirusTotal-Analyse',
      reputation: 'Reputation',
      malicious: 'Bösartig',
      suspicious: 'Verdächtig',
      harmless: 'Harmlos',
      undetected: 'Nicht erkannt'
    },
    errors: {
      scanFailed: 'Scan fehlgeschlagen',
      insufficientCredits: 'Unzureichende Credits',
      invalidDomain: 'Ungültige Domain',
      networkError: 'Netzwerkfehler'
    }
  },

  // Support
  support: {
    title: 'Support',
    myTickets: 'Meine Support-Tickets',
    manageRequests: 'Verwalten Sie Ihre Supportanfragen',
    newTicket: 'Neues Ticket',
    ticketDetails: 'Ticket-Details',
    subject: 'Betreff',
    message: 'Nachricht',
    priority: 'Priorität',
    status: 'Status',
    category: 'Kategorie',
    created: 'Erstellt',
    createdOn: 'Erstellt am',
    updated: 'Letzte Aktualisierung',
    resolved: 'Gelöst',
    resolvedOn: 'Gelöst am',
    noTickets: 'Keine Tickets',
    noTicketsFound: 'Keine Tickets gefunden',
    noTicketsYet: 'Sie haben noch kein Support-Ticket erstellt',
    tryModifyingSearch: 'Versuchen Sie, Ihre Suchkriterien zu ändern',
    createFirstTicket: 'Mein erstes Ticket erstellen',
    sendMessage: 'Nachricht senden',
    send: 'Senden',
    sending: 'Wird gesendet...',
    closeTicket: 'Ticket schließen',
    closing: 'Wird geschlossen...',
    ticketClosed: 'Dieses Ticket ist geschlossen. Für eine neue Anfrage erstellen Sie ein neues Ticket.',
    search: 'Ticket suchen...',
    allStatuses: 'Alle Status',
    refresh: 'Aktualisieren',
    backToTickets: 'Zurück zu den Tickets',
    ticketNumber: 'Nummer',
    you: 'Sie',
    supportTeam: 'SYLink Support',
    system: 'System',
    writeReply: 'Schreiben Sie Ihre Antwort...',
    detailedDescription: 'Detaillierte Beschreibung',
    informations: 'Informationen',
    needHelp: 'Brauchen Sie Hilfe?',
    responseTime: 'Geschätzte Antwortzeit',
    responseTimeDesc: 'Unser Team antwortet in der Regel innerhalb von 24 Geschäftsstunden.',
    supportResponseDesc: 'Unser Support-Team antwortet in der Regel innerhalb von 24 Geschäftsstunden.',
    newTicketTitle: 'Neues Ticket',
    newTicketDesc: 'Beschreiben Sie Ihr Problem und unser Team wird Ihnen schnell antworten',
    describeIssue: 'Beschreiben Sie kurz Ihr Problem...',
    relatedWorkspace: 'Betroffener Kunde / Workspace (optional)',
    noSpecificWorkspace: 'Kein bestimmter Workspace',
    detailedDescPlaceholder: 'Beschreiben Sie Ihr Problem im Detail...',
    charactersCount: '{count} Zeichen',
    charactersMin: '{count} Zeichen (mindestens {min})',
    cancel: 'Abbrechen',
    createTicket: 'Ticket erstellen',
    creating: 'Wird erstellt...',
    rateSupport: 'Wie bewerten Sie die Qualität unseres Supports?',
    comment: 'Kommentar (optional)...',
    confirm: 'Bestätigen',
    messages: 'Nachricht',
    messagesPlural: 'Nachrichten',
    resolutionNotes: 'Lösungshinweise',
    yourRating: 'Ihre Bewertung',
    statuses: {
      open: 'Offen',
      in_progress: 'In Bearbeitung',
      waiting_customer: 'Wartet auf Ihre Antwort',
      waiting_internal: 'In Bearbeitung',
      resolved: 'Gelöst',
      closed: 'Geschlossen'
    },
    priorities: {
      low: 'Niedrig',
      medium: 'Mittel',
      high: 'Hoch',
      urgent: 'Dringend',
      lowDesc: 'Nicht dringend, kann warten',
      mediumDesc: 'Normale Wichtigkeit',
      highDesc: 'Erfordert schnelle Aufmerksamkeit',
      urgentDesc: 'Kritische Auswirkung auf die Aktivität',
      priority: 'Priorität'
    },
    categories: {
      technical: 'Technisch',
      billing: 'Abrechnung',
      feature_request: 'Funktionsanfrage',
      bug_report: 'Fehlerbericht',
      account: 'Konto',
      security: 'Sicherheit',
      other: 'Sonstiges',
      technicalDesc: 'Technische Probleme, Fehler, Störungen',
      billingDesc: 'Fragen zu Rechnungen, Zahlungen, Abonnements',
      feature_requestDesc: 'Verbesserungsvorschläge oder neue Funktionen',
      bug_reportDesc: 'Einen Fehler oder unerwartetes Verhalten melden',
      accountDesc: 'Kontoverwaltung, Zugang, Berechtigungen',
      securityDesc: 'Sicherheitsfragen oder -bedenken',
      otherDesc: 'Andere Art von Anfrage'
    },
    errors: {
      loadingTickets: 'Fehler beim Laden der Tickets',
      loadingTicket: 'Fehler beim Laden des Tickets',
      sendingMessage: 'Fehler beim Senden der Nachricht',
      closingTicket: 'Fehler beim Schließen des Tickets',
      creatingTicket: 'Fehler beim Erstellen des Tickets',
      ticketNotFound: 'Ticket nicht gefunden',
      retry: 'Erneut versuchen',
      fixFormErrors: 'Bitte korrigieren Sie die Fehler im Formular',
      subjectRequired: 'Betreff ist erforderlich',
      subjectMinLength: 'Der Betreff muss mindestens 5 Zeichen enthalten',
      descriptionRequired: 'Beschreibung ist erforderlich',
      descriptionMinLength: 'Die Beschreibung muss mindestens 20 Zeichen enthalten'
    },
    success: {
      ticketCreated: 'Ticket {number} erfolgreich erstellt',
      messageSent: 'Nachricht gesendet',
      ticketClosed: 'Ticket erfolgreich geschlossen'
    }
  },

  // Pricing
  pricing: {
    title: 'Wählen Sie Ihren Plan',
    subtitle: 'Sicherheitslösungen für Unternehmen jeder Größe.',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    yearlyDiscount: '-17%',
    perMonth: 'Monat',
    perYear: 'Jahr',
    ht: 'zzgl. MwSt.',
    or: 'Das heißt',
    perMonthShort: '/Monat',
    onQuote: 'Auf Anfrage',
    free: 'Kostenlos',
    plans: {
      gratuit: {
        name: 'Kostenlos',
        subtitle: 'Entdeckung',
        description: 'Ideal zum Testen der Plattform',
        cta: 'Kostenlos starten'
      },
      pro: {
        name: 'Pro',
        subtitle: 'Am beliebtesten',
        description: 'Für Profis und KMU',
        cta: 'Pro wählen',
        badge: 'Empfohlen'
      },
      entreprise: {
        name: 'Enterprise',
        subtitle: 'Für große Teams',
        description: 'Erweiterte Funktionen und dedizierter Support',
        cta: 'Enterprise wählen'
      },
      entreprise_plus: {
        name: 'Gruppe',
        subtitle: 'Für große Organisationen',
        description: 'Erweitertes Volumen und Premium-Support',
        cta: 'Gruppe wählen'
      },
      sur_mesure: {
        name: 'Maßgeschneidert',
        subtitle: 'Individuelle Lösung',
        description: 'Angepasst an Ihre spezifischen Bedürfnisse',
        cta: 'Kontaktieren Sie uns'
      }
    },
    features: {
      simulationOnly: 'Nur Simulationsmodus',
      oneUser: '1 Benutzer',
      oneTarget: '1 Testziel',
      basicDashboard: 'Basis-Dashboard',
      realScans: 'Echte Scans',
      pdfReports: 'PDF-Berichte',
      technicalSupport: 'Technischer Support',
      apiAccess: 'API-Zugang',
      unlimitedScans: 'Unbegrenzte KI-Scans',
      fiveUsers: '5 Benutzer',
      tenTargets: '10 Ziele',
      customPdfReports: 'Benutzerdefinierte PDF-Berichte',
      credentialSearch: 'Anmeldedaten-Suche',
      autoScheduling: 'Automatische Planung',
      prioritySupport: 'Prioritäts-Support',
      allProFeatures: 'Alle Pro-Funktionen +',
      fifteenUsers: '15 Benutzer',
      thirtyTargets: '30 Ziele',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Compliance-Audit',
      slaGuarantee: 'SLA 99,9% garantiert',
      dedicatedSupport: 'Dedizierter Support',
      teamTraining: 'Team-Schulung inklusive',
      allEnterpriseFeatures: 'Alle Enterprise-Funktionen +',
      unlimitedUsers: 'Unbegrenzte Benutzer',
      fiftyTargets: '50 Ziele',
      advancedWorkspaces: 'Erweiterte Multi-Workspaces',
      whiteLabelReports: 'White-Label-Berichte',
      support24_7: 'Dedizierter Support 24/7',
      accountManager: 'Dedizierter Account Manager',
      customOnboarding: 'Personalisiertes Onboarding',
      allGruppeFeatures: 'Alle Gruppe-Funktionen +',
      dedicatedInfra: 'Dedizierte Infrastruktur',
      customIntegrations: 'Benutzerdefinierte Integrationen',
      specificDevelopment: 'Spezifische Entwicklungen',
      sourceCodeAudit: 'Quellcode-Audit',
      manualPentest: 'Manuelle Penetrationstests',
      cissoSupport: 'CISO-Begleitung',
      customContract: 'Maßgeschneiderter Vertrag'
    },
    whyChoose: 'Warum SYLink Pentest wählen?',
    aiTitle: 'Künstliche Intelligenz',
    aiDesc: 'Unsere KI analysiert und nutzt Schwachstellen autonom aus.',
    securityTitle: 'Maximale Sicherheit',
    securityDesc: 'Ihre Daten sind verschlüsselt und sicher.',
    reportsTitle: 'Detaillierte Berichte',
    reportsDesc: 'Erstellen Sie professionelle PDF-Berichte mit Empfehlungen.',
    faqTitle: 'Häufig gestellte Fragen',
    faqCanChangePlan: 'Kann ich den Plan wechseln?',
    faqCanChangePlanAnswer: 'Ja, Sie können jederzeit upgraden oder downgraden.',
    faqFreePlan: 'Wie funktioniert der kostenlose Plan?',
    faqFreePlanAnswer: 'Der kostenlose Plan ermöglicht es Ihnen, die Plattform im Simulationsmodus zu testen.',
    faqCommitment: 'Gibt es eine Bindung?',
    faqCommitmentAnswer: 'Nein, keine Bindung. Sie können jederzeit kündigen.',
    faqSupport: 'Welcher Support ist enthalten?',
    faqSupportAnswer: 'Der Pro-Plan beinhaltet Prioritäts-Support per E-Mail.',
    needHelpChoosing: 'Brauchen Sie Hilfe bei der Auswahl?',
    needHelpDesc: 'Unser Team steht Ihnen zur Verfügung.',
    contactUs: 'Kontaktieren Sie uns',
    requestCall: 'Rückruf anfordern',
    welcomeTitle: 'Willkommen bei SYLink Pentest!',
    welcomeDesc: 'Ihr Konto ist aktiviert. Wählen Sie den Plan, der Ihren Bedürfnissen entspricht.',
    paymentError: 'Zahlungsfehler',
    close: 'Schließen',
    redirecting: 'Weiterleitung...',
    securedByStripe: 'Sichere Zahlung über Stripe'
  },

  // Notifications
  notifications: {
    managementCenter: 'Verwaltungszentrum für Warnungen und Ereignisse',
    aiAssistant: 'KI-Assistent',
    aiAssistantTitle: 'KI-Assistent - Benachrichtigungen',
    aiPlaceholder: 'Stellen Sie eine Frage zu Ihren Benachrichtigungen...',
    settings: 'Benachrichtigungseinstellungen',
    soundEnabled: 'Töne aktiviert',
    criticalOnly: 'Nur kritische',
    autoMarkRead: 'Automatisch als gelesen markieren',
    filters: 'Filter',
    total: 'Gesamt',
    unread: 'Ungelesen',
    critical: 'Kritisch',
    warning: 'Warnung',
    success: 'Erfolg',
    info: 'Info',
    markAllRead: 'Alle als gelesen markieren',
    clearAll: 'Alle löschen',
    noNotifications: 'Keine Benachrichtigungen',
    noNotificationsDesc: 'Sie haben derzeit keine Benachrichtigungen',
    allRead: 'Alle Ihre Benachrichtigungen sind gelesen',
    noNotificationsType: 'Keine Benachrichtigungen vom Typ "{type}"',
    typeCritical: 'Kritisch',
    typeWarning: 'Warnung',
    typeSuccess: 'Erfolg',
    typeInfo: 'Info',
    criticalVulnsFound: '{count} kritische Schwachstelle(n)',
    vulnsDetected: '{count} Schwachstelle(n) erkannt',
    hostsScanned: '{count} Hosts auf {target} gescannt',
    scanCompletedNoVulns: 'Scan abgeschlossen - Keine Schwachstellen',
    noVulnsDetected: 'Keine Schwachstellen auf {target} erkannt',
    scanInProgress: 'Scan läuft',
    analyzing: 'Analyse von {target}...',
    scanFailed: 'Scan fehlgeschlagen',
    errorOn: 'Fehler bei {target}',
    justNow: 'Gerade eben',
    minutesAgo: 'vor {count}min',
    hoursAgo: 'vor {count}h',
    daysAgo: 'vor {count}T',
    scanRunning: 'Scan läuft',
    viewAll: 'Alle Benachrichtigungen anzeigen',
    scanCompleted: 'Scan abgeschlossen'
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Antivirus-Scanner',
    subtitle: 'Dateien mit ClamAV auf Malware scannen',
    adminTitle: 'Antivirus-Verwaltung',
    adminSubtitle: 'ClamAV überwachen und Quarantäne verwalten',
    scannerTab: 'Datei-Scanner',
    adminTab: 'Verwaltung',

    // File Upload
    dropzone: 'Datei hier ablegen oder klicken zum Hochladen',
    dropzoneActive: 'Datei hier ablegen...',
    scanning: 'Wird gescannt...',
    uploadAndScan: 'Hochladen & Scannen',
    maxFileSize: 'Maximale Dateigröße: {size}',

    // Scan Results
    scanResult: 'Scan-Ergebnis',
    clean: 'Sauber',
    infected: 'Infiziert',
    error: 'Fehler',
    pending: 'Ausstehend',
    threatDetected: 'Bedrohung erkannt',
    noThreatsFound: 'Keine Bedrohungen gefunden',
    threatName: 'Bedrohungsname',
    scanTime: 'Scan-Zeit',
    fileHash: 'Datei-Hash',

    // History
    scanHistory: 'Scan-Verlauf',
    noScansYet: 'Noch keine Scans',
    noScansYetDesc: 'Laden Sie eine Datei hoch um mit dem Scannen zu beginnen',

    // Admin Dashboard
    clamavStatus: 'ClamAV-Status',
    version: 'Version',
    signatureCount: 'Signaturanzahl',
    lastUpdate: 'Letztes Update',
    databaseStatus: 'Datenbank-Status',
    upToDate: 'Aktuell',
    outdated: 'Veraltet',

    // Statistics
    statistics: 'Statistiken',
    totalScans: 'Gesamt-Scans',
    cleanFiles: 'Saubere Dateien',
    infectedFiles: 'Infizierte Dateien',
    errorScans: 'Fehlerhafte Scans',

    // Quarantine
    quarantine: 'Quarantäne',
    quarantineEmpty: 'Quarantäne ist leer',
    quarantineEmptyDesc: 'Keine Dateien in Quarantäne',
    deleteFromQuarantine: 'Aus Quarantäne löschen',
    cleanupQuarantine: 'Quarantäne bereinigen',

    // Errors
    uploadError: 'Fehler beim Hochladen der Datei',
    scanError: 'Fehler beim Scannen der Datei',
    fileTooLarge: 'Datei ist zu groß',
    invalidFileType: 'Ungültiger Dateityp',
    serviceUnavailable: 'Antivirus-Dienst nicht verfügbar'
  },

  // Contracts
  contracts: {
    title: 'Verträge',
    contract: 'Vertrag',
    newContract: 'Neuer Vertrag',
    createContract: 'Vertrag erstellen',
    editContract: 'Vertrag bearbeiten',
    contractNumber: 'Vertragsnummer',
    contractTitle: 'Titel',

    // Status
    status: {
      draft: 'Entwurf',
      pending_signature: 'Warten auf Unterschrift',
      signed: 'Unterzeichnet',
      active: 'Aktiv',
      completed: 'Abgeschlossen',
      expired: 'Abgelaufen',
      cancelled: 'Storniert'
    },

    // Provider
    provider: 'Dienstleister',
    providerInfo: 'Dienstleisterinformationen',
    providerName: 'Firmenname',
    providerSiret: 'SIRET',
    providerAddress: 'Adresse',

    // Client
    client: 'Kunde',
    clientInfo: 'Kundeninformationen',
    clientName: 'Firmenname',
    clientRepresentative: 'Kundenvertreter',
    clientContact: 'Kontakt',

    // Perimeter
    perimeter: 'Geltungsbereich',
    perimeterDescription: 'IP-Bereiche und zu testende Ziele',
    addPerimeterItem: 'Geltungsbereich hinzufügen',

    // Period
    interventionPeriod: 'Interventionszeitraum',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    riskPeriod: 'Risikozeitraum (Tage)',

    // Signature
    signature: {
      title: 'Elektronische Unterschrift',
      sign: 'Unterschreiben',
      signed: 'Unterzeichnet',
      pendingSignature: 'Warten auf Unterschrift',
      signContract: 'Vertrag unterschreiben',
      signatureType: 'Unterschriftstyp',
      typed: 'Getippt',
      drawn: 'Gezeichnet',
      uploaded: 'Hochgeladen',

      // Signatory
      signatory: 'Unterzeichner',
      signatoryInfo: 'Unterzeichner-Identität',
      signatoryFirstName: 'Vorname',
      signatoryLastName: 'Nachname',
      signatoryEmail: 'E-Mail',
      signatoryFullName: 'Vollständiger Name',

      // Legal
      legalMention: 'Rechtlicher Hinweis',
      legalAcceptance: 'Ich akzeptiere die Vertragsbedingungen',
      acceptTerms: 'Ich bestätige, diesen Pentest-Vertrag gelesen und akzeptiert zu haben',

      // Verification
      verification: 'Überprüfung',
      verificationMethod: 'Überprüfungsmethode',
      smsVerification: 'SMS-Überprüfung',
      smsCode: 'SMS-Code',
      sendCode: 'Code senden',
      verifyCode: 'Code überprüfen',
      codeExpired: 'Code abgelaufen',
      invalidCode: 'Ungültiger Code',
      codeSent: 'Code an Ihr Telefon gesendet',

      // Metadata (DocuSign-style)
      metadata: 'Unterschriftsmetadaten',
      signedBy: 'Unterzeichnet von',
      signedAt: 'Unterschrieben am',
      signedAtTime: 'Uhrzeit der Unterschrift',
      ipAddress: 'IP-Adresse',
      userAgent: 'Browser / Gerät',
      geolocation: 'Standort',

      // Certificate
      certificate: 'Unterschriftszertifikat',
      certificateOfCompletion: 'Abschlusszertifikat',
      signatureCertificate: 'Unterschriftszertifikat',
      downloadCertificate: 'Zertifikat herunterladen',
      viewCertificate: 'Zertifikat anzeigen',

      // Integrity
      integrity: 'Dokumentenintegrität',
      documentHash: 'Dokument-Hash (SHA-512)',
      signatureHash: 'Unterschrifts-Hash (SHA-512)',
      hashVerified: 'Hash verifiziert',
      hashMismatch: 'Hash-Fehler',

      // Timeline / Audit
      timeline: 'Zeitlinie',
      auditTrail: 'Prüfprotokoll',
      eventLog: 'Ereignisprotokoll',
      created: 'Erstellt',
      sent: 'Gesendet',
      viewed: 'Angesehen',
      signatureStarted: 'Unterschrift gestartet',
      signatureCompleted: 'Unterschrift abgeschlossen',

      // Success
      success: 'Vertrag erfolgreich unterzeichnet!',
      successMessage: 'Der Vertrag wurde unterzeichnet und ist jetzt aktiv.',
      thankYou: 'Vielen Dank für Ihre Unterschrift',

      // Errors
      error: 'Unterschriftsfehler',
      errorMessage: 'Vertrag konnte nicht unterzeichnet werden',
      expired: 'Unterschriftslink abgelaufen',
      alreadySigned: 'Vertrag bereits unterzeichnet',
      invalidToken: 'Ungültiger Unterschriftslink'
    },

    // Actions
    send: 'Zur Unterschrift senden',
    resend: 'Erneut senden',
    cancel: 'Vertrag stornieren',
    download: 'PDF herunterladen',
    downloadSigned: 'Unterzeichnetes PDF herunterladen',
    preview: 'Vorschau',

    // Notifications
    sentSuccess: 'Vertrag zur Unterschrift gesendet',
    signedSuccess: 'Vertrag erfolgreich unterzeichnet',
    cancelledSuccess: 'Vertrag storniert'
  },

  // VPN Configuration
  vpn: {
    title: 'VPN-Konfiguration',
    configurations: 'VPN-Konfigurationen',
    noConfigurations: 'Keine VPN-Konfigurationen',
    uploadConfig: 'Konfiguration hochladen',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    connecting: 'Verbinde...',
    disconnecting: 'Trenne...',
    connect: 'Verbinden',
    disconnect: 'Trennen',
    status: 'VPN-Status',
    protocol: 'Protokoll',
    interface: 'Schnittstelle',
    publicIp: 'Öffentliche IP',
    vpnIp: 'VPN-IP',
    country: 'Land',
    city: 'Stadt',
    connectedSince: 'Verbunden seit',
    routes: {
      title: 'Netzwerkrouten',
      description: 'Benutzerdefinierte Netzwerkrouten für VPN verwalten',
      addRoute: 'Route hinzufügen',
      destination: 'Ziel-CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Gateway',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Beschreibung',
      routeDescriptionPlaceholder: 'Internes Kundennetzwerk',
      noRoutes: 'Keine Routen konfiguriert',
      deleteRoute: 'Route löschen',
      applyRoutes: 'Routen anwenden',
      routeAdded: 'Route erfolgreich hinzugefügt',
      routeDeleted: 'Route gelöscht',
      routesApplied: 'Routen angewendet',
      invalidCidr: 'Ungültiges CIDR-Format',
      invalidGateway: 'Ungültige IP-Adresse',
      active: 'Aktiv',
      inactive: 'Inaktiv'
    },
    topology: {
      title: 'Netzwerktopologie',
      server: 'Sylink-Server',
      internet: 'Internet',
      vpnGateway: 'VPN-Gateway',
      clientNetwork: 'Kundennetzwerk',
      online: 'Online',
      offline: 'Offline',
      activeRoutes: 'Aktive Routen',
      totalRoutes: 'Gesamtrouten'
    },
    messages: {
      configUploaded: 'VPN-Konfiguration hochgeladen',
      configDeleted: 'VPN-Konfiguration gelöscht',
      connectionSuccess: 'VPN erfolgreich verbunden',
      connectionFailed: 'VPN-Verbindungsfehler',
      disconnectionSuccess: 'VPN getrennt',
      disconnectionFailed: 'VPN-Trennungsfehler'
    }
  }

};
